import { faBell } from "@fortawesome/free-regular-svg-icons";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import Badge from "../../common/badge/Badge";
import Line from "../../common/line/Line";
import City from "./City";
import BurgerMenu from "./menu/BurgerMenu";
import Logo from "./menu/Logo";
import UserInfo from "./menu/UserInfo";
import {
  NavigationBar,
  NavigationDropdownMenuItem,
  NavigationEnd,
  NavigationLink,
  NavigationStart,
} from "./navigation";
import { InfoBarContext } from "../../common/info";
import { ThemeContext } from "../../common/theme/ThemeContext";
import NotificationPanel from "../../common/notifications/NotificationPanel";
import { isDesktop } from "../../utils/screenUtil";

function Header({ user }) {
  const location = useLocation();
  const { t } = useTranslation();
  const infoBar = useContext(InfoBarContext);
  const theme = useContext(ThemeContext);

  const toggleNotifications = () =>
    infoBar.toggle(`${t("notifications.title")}`, () => <NotificationPanel />);

  return (
    <header className="hero-head">
      <nav className={`navbar has-background-${theme.navColor}`}>
        <Logo img={theme.logo}>
          <BurgerMenu
            backgroundBulmaColor={theme.navLinkColor}
            textBulmaColor={theme.iconColor}
            hoverBulmaColor={theme.iconColor}
          />
        </Logo>
        <City link={user.applicationConfiguration.dashboardUri} name={user.place}>
          <Badge
            className="is-clickable is-pulled-right is-hidden-desktop mt-2"
            iconBulmaColor={theme.navText}
            value={user.unreadNotifications}
            icon={faBell}
            onClick={toggleNotifications}
          />
        </City>
        <NavigationBar id={"navigation"} backgroundBulmaColor={theme.navColor}>
          <NavigationStart
            isHidden={location.pathname === user.applicationConfiguration.dashboardUri}
          >
            <NavigationDropdownMenuItem
              label={t("requests.title").toUpperCase()}
              displayDropdownMenu={location.pathname !== user.applicationConfiguration.dashboardUri}
              isHorizontal={true}
              displayLabel={false}
            >
              <NavigationLink exact={true} to="/submitRequest" label={t("requests.submit")} />
              <NavigationLink
                exact={false}
                to="/requests"
                label={t("requests.created")}
                className={isDesktop() ? "ml-1" : ""}
              />
              <NavigationLink
                exact={true}
                to="/archive"
                label={t("requests.archive")}
                className={isDesktop() ? "ml-1" : ""}
              />
            </NavigationDropdownMenuItem>
          </NavigationStart>
          <NavigationEnd>
            <UserInfo />
          </NavigationEnd>
        </NavigationBar>
      </nav>
      <Line className="is-hidden-touch" height={64} color={theme.lineColor}>
        <div className="container is-pulled-right has-text-right mr-4 mt-4 is-clickable">
          <Badge
            size={2}
            iconBulmaColor={theme.navLinkColor}
            value={user.unreadNotifications}
            icon={faBell}
            iconSize={2}
            onClick={toggleNotifications}
          />
        </div>
      </Line>
      <div style={{ borderBottom: "3px solid #192e3c" }}></div>
    </header>
  );
}

export default Header;
